'use client';
import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { classifyError, serverText } from './errorMessage';

/**
 * The sentence for a failed write, for places that show it inline instead of as a toast:
 * the server's own prose when it wrote some, else a translated sentence for the failure kind.
 */
export function useErrorMessage(): (err: unknown) => string {
  const t = useTranslations('Common');
  return useCallback(
    (err: unknown) => {
      const kind = classifyError(err);
      const prose = kind === 'server' || kind === 'network' ? null : serverText(err);
      return prose ?? t(`errors.${kind}`);
    },
    [t],
  );
}
